import React from "react";
import { Navbar } from "@blueprintjs/core";
import { ReactComponent as BrandSvg } from "../assets/BrandIcon.svg";
import styled from "styled-components";
import { ReactComponent as SemgrepText } from "../assets/SemgrepTextLightTheme.svg";

const Logo = styled(Navbar.Heading)`
  display: flex;
  align-items: center;
  margin-right: 8px;
`;

export const BrandIcon = styled(BrandSvg)`
  height: 16px;
  width: 48px;
  transition: fill 0.3s ease, transform 0.3s ease;
  @media (prefers-reduced-motion) {
    transform: rotate(0deg) !important;
  }
  ${Logo}:hover & {
    transform: rotate(-180deg);
  }
`;

export const NavbarLogo: React.FC<{}> = () => (
  <Logo>
    <SemgrepText width="80px" height="20px" />
    <BrandIcon />
  </Logo>
);
